import colorConfig from "./color-config.json";

const COLOR_ENTRIES = colorConfig.colors;

const resolveValue = (compConfig, entry) => {
  const direct = compConfig[entry.configKey];
  if (direct != null) return direct;
  if (entry.fallbackConfigKey) {
    const fallback = compConfig[entry.fallbackConfigKey];
    if (fallback != null) return fallback;
  }
  return null;
};

const setVar = (style, cssVar, value) => {
  if (value != null) style[cssVar] = value;
};

export const buildThemeStyle = (compConfig, hasDataConfig) => {
  if (!hasDataConfig) return {};

  const style = {};

  for (const entry of COLOR_ENTRIES) {
    if (entry.derived) continue;
    const value = resolveValue(compConfig, entry);
    if (value == null) continue;
    setVar(style, entry.cssVar, value);
    if (entry.extraCssVars) {
      for (const extra of entry.extraCssVars) {
        if (entry.configKey === "colorBg" && extra === "--kbv-bg-page") {
          if (compConfig.colorPageBg != null) continue;
        }
        if (entry.configKey === "colorForeground" && extra === "--kbv-card-bg") {
          if (compConfig.colorCardBg != null) continue;
        }
        if (entry.configKey === "colorBorder" && extra === "--kbv-card-border") {
          if (compConfig.colorCardBorder != null) continue;
        }
        if (entry.configKey === "colorTextMuted" && extra === "--text-half-score") {
          if (compConfig.colorHalfScore != null) continue;
        }
        setVar(style, extra, value);
      }
    }
  }

  const highlight = compConfig.colorSecondary;

  if (compConfig.colorPrimaryHover == null && highlight != null) {
    setVar(style, "--theme-primary-hover", highlight);
  }

  return style;
};

export { colorConfig };
